/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: Fix accessibility

import { useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import {
  Filter,
  FilterOptionValue,
} from '../../hooks/filters/interfaces/filter.interface';
import { IMAGES_REPO } from '../../static-resources';
import { DropdownToggleButtonComponent } from './dropdown-toggle-button.component';
import { FilterOptionGroupSelectedValue } from './multiple-selection.component';
import './multiple-selection-option-group.component.scss';

export interface MultipleSelectionOptionGroupProps {
  disabled?: boolean;
  filter: Filter;
  g: FilterOptionGroupSelectedValue;
  isChecked(option: FilterOptionValue): boolean;
  isGroupChecked(option: FilterOptionValue): boolean;
  changeHandler(checked: boolean, option: FilterOptionValue): void;
  changeGroupHandler(
    checked: boolean,
    optionGroup: FilterOptionGroupSelectedValue,
  ): void;

  counter: number;
}
export const MultipleSelectionOptionGroup = ({
  counter,
  filter,
  g,
  isChecked,
  isGroupChecked,
  changeHandler,
  changeGroupHandler,
  disabled,
}: MultipleSelectionOptionGroupProps) => {
  const [show, setShow] = useState(false);
  if (g.options.length === 1) {
    const i = g.options[0];
    return (
      <div
        className={`dropdown-item-component ${isChecked(i) ? 'active' : ''}`}
      >
        <Form.Check
          disabled={disabled}
          name={filter.id}
          id={`${filter.id}-${i.value}`}
          label={i.label}
          type="checkbox"
          checked={isChecked(i)}
          value={i.value}
          onChange={(e) => changeHandler(e.currentTarget.checked, i)}
        />
      </div>
    );
  }
  return (
    <div
      className={`dropdown-item-component ${isGroupChecked(g) ? 'active' : ''}`}
    >
      <Form.Check
        disabled={disabled}
        name={filter.id}
        id={`${filter.id}-${g.value}`}
        label={g.label}
        type="checkbox"
        checked={isGroupChecked(g)}
        value={g.value}
        onChange={(e) => changeGroupHandler(e.currentTarget.checked, g)}
      />
      {counter > 0 && (
        <div className="dropdown-group-item-badge">{counter}</div>
      )}

      <Dropdown
        autoClose
        onToggle={(toggle) => () => setShow(toggle)}
        placement="left-end"
        align={'end'}
      >
        <Dropdown.Toggle as={DropdownToggleButtonComponent} open={show} />
        <Dropdown.Menu>
          {g.options.map((i, index) => (
            <div
              key={index}
              className={`dropdown-menu-item ${isChecked(i) ? 'active' : ''}`}
            >
              <Form.Check
                disabled={disabled}
                name={filter.id}
                id={`${filter.id}-${i.value}`}
                label={i.label}
                type="checkbox"
                checked={isChecked(i)}
                value={i.value}
                onChange={(e) => changeHandler(e.currentTarget.checked, i)}
              />
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export const MultipleSelectionOptionSimple = ({
  counter,
  filter,
  g,
  isChecked,
  isGroupChecked,
  changeHandler,
  changeGroupHandler,
  disabled,
}: MultipleSelectionOptionGroupProps) => {
  const [show, setShow] = useState(false);
  if (g.options.length === 1) {
    const i = g.options[0];
    return (
      <Dropdown.Item
        className={`${isChecked(i) ? 'filter-dropdown-component-item-active' : ''}`}
        onClick={() => changeHandler(!isChecked(i), i)}
      >
        <Form.Check
          disabled={disabled}
          name={filter.id}
          id={`${filter.id}-${i.value}`}
          label={i.label}
          type="checkbox"
          checked={isChecked(i)}
          value={i.value}
          onChange={(e) => changeHandler(e.currentTarget.checked, i)}
        />
      </Dropdown.Item>
    );
  }
  return (
    <>
      <Dropdown.Item
        className={`filter-dropdown-component-item  ${isGroupChecked(g) ? 'filter-dropdown-component-item-active' : ''}`}
      >
        <Form.Check
          disabled={disabled}
          name={filter.id}
          id={`${filter.id}-${g.value}`}
          label={g.label}
          type="checkbox"
          checked={isGroupChecked(g)}
          value={g.value}
          onChange={(e) => changeGroupHandler(e.currentTarget.checked, g)}
        />
        {counter > 0 && (
          <div className="dropdown-group-item-badge">{counter}</div>
        )}

        <img
          className={`filter-dropdown-component-item-dropdown-button ${show ? 'open' : 'close'}`}
          src={IMAGES_REPO.SimpleArrow}
          loading="lazy"
          alt=""
          height={18}
          width={18}
          onClick={() => setShow(!show)}
        />
      </Dropdown.Item>
      <div
        className={`filter-dropdown-component-item-dropdown-content ${show ? 'open' : 'close'}`}
      >
        {g.options.map((i, index) => (
          <Dropdown.Item
            key={index}
            className={`${isChecked(i) ? 'filter-dropdown-component-item-active' : ''}`}
            onClick={() => changeHandler(!isChecked(i), i)}
          >
            <Form.Check
              disabled={disabled}
              name={filter.id}
              id={`${filter.id}-${i.value}`}
              label={i.label}
              type="checkbox"
              checked={isChecked(i)}
              value={i.value}
              onChange={(e) => changeHandler(e.currentTarget.checked, i)}
            />
          </Dropdown.Item>
        ))}
      </div>
    </>
  );
};
